export default __webpack_public_path__ + "8f3f440199a50f9f287cbf263c03be7f.png";